import { render, staticRenderFns } from "./Administrative.vue?vue&type=template&id=5a6c10f2"
import script from "./Administrative.vue?vue&type=script&lang=js"
export * from "./Administrative.vue?vue&type=script&lang=js"
import style0 from "./Administrative.vue?vue&type=style&index=0&id=5a6c10f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports